import img_portrait from '../img/img_portrait_cut.JPG';
import CV from '../doc/Gautier_VASSE_CV.pdf';

import Competences from './Competences';
import { FaLinkedin, FaYoutube } from 'react-icons/fa';

export default function WhoAmI() {
  return (
    <>
      <div className="w-full px-4  sm:px-6 md:px-8 lg:px-12 xl:px-16 2xl:px-24 pb-8 sm:pb-12 md:pb-16 lg:pb-20 bg-white flex flex-col items-center justify-center">
        <h1 className="text-2xl sm:text-3xl md:text-4xl lg:text-4xl xl:text-5xl text-center font-light mt-6 sm:mt-8 md:mt-10 lg:mt-12 px-2 sm:px-4 md:px-6 lg:px-8 pb-4 sm:pb-6 md:pb-8">
          Qui suis-je ?
        </h1>
        <div className="md:w-[60%] px-4 sm:px-6 md:px-8 lg:px-6 xl:px-8 2xl:px-10 py-6 sm:py-8 md:py-10 lg:py-8 xl:py-10 sm:bg-gray-50 md:bg-gray-100 lg:bg-gray-100 xl:bg-gray-100 sm:rounded-xl md:rounded-2xl lg:rounded-2xl xl:rounded-2xl sm:shadow-lg md:shadow-xl lg:shadow-xl xl:shadow-xl w-full max-w-7xl">
          <h1 className="text-xl sm:text-2xl md:text-3xl lg:text-4xl xl:text-4xl 2xl:text-5xl font-semibold text-center mb-4 sm:mb-6 md:mb-8">
            GAUTIER VASSE
          </h1>
          <div className="flex flex-col lg:flex-row mt-4 sm:mt-6 md:mt-8 space-y-4 lg:space-y-0 lg:space-x-6 xl:space-x-8 2xl:space-x-10">
            <div className="flex justify-center lg:justify-start lg:flex-shrink-0">
              <img
                className="w-32 sm:w-40 md:w-48 lg:w-44 xl:w-52 2xl:w-60 h-auto object-cover rounded-2xl sm:rounded-3xl md:rounded-4xl shadow-lg sm:shadow-xl"
                src={img_portrait}
                alt="Gautier VASSE"
              />
            </div>
            <blockquote className="italic text-gray-700 p-3 sm:p-4 md:p-6 lg:p-4 xl:p-6 text-sm sm:text-base md:text-lg lg:text-base xl:text-lg 2xl:text-xl leading-relaxed text-center lg:text-left flex items-center">
              "En tant que micro-entrepreneur, j'ai développé mon expertise de façon autodidacte depuis 4 ans. Parallèlement, je poursuis des études d'ingénieur, me spécialisant en intelligence artificielle et en génie logiciel."
            </blockquote>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 md:gap-4 lg:gap-6 xl:gap-8">
            <div className="w-full bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl mt-6 sm:mt-8 p-4 sm:p-5 md:p-6 lg:p-5 xl:p-6 pb-6 sm:pb-8 flex flex-col items-center">
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl font-light mb-3 sm:mb-4 md:mb-6 text-center">
                Compétences
              </h2>
              {/* Bloc Compétences avec animation de défilement infini */}
              <div className="w-full">
                <Competences />
              </div>
            </div>
            
            <div className="w-full bg-white rounded-xl sm:rounded-2xl shadow-lg sm:shadow-xl mt-6 sm:mt-8 p-4 sm:p-5 md:p-6 lg:p-5 xl:p-6 pb-6 sm:pb-8 flex flex-col items-center">
              <h2 className="text-lg sm:text-xl md:text-2xl lg:text-xl xl:text-2xl 2xl:text-3xl font-light mb-3 sm:mb-4 md:mb-6 text-center">
                Réseaux
              </h2>
              <div className="flex space-x-6 sm:space-x-8 md:space-x-6 lg:space-x-8">
                <a href="https://www.linkedin.com/in/gautier-vasse-366031238/" target="_blank" rel="noopener noreferrer" className="transition-transform duration-300 hover:scale-110">
                  <FaLinkedin className="w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 lg:w-8 lg:h-8 xl:w-10 xl:h-10 text-blue-700 hover:text-blue-800" />
                </a>
                <a href="https://www.youtube.com/@electroniquearduino9744" target="_blank" rel="noopener noreferrer" className="transition-transform duration-300 hover:scale-110">
                  <FaYoutube className="w-7 h-7 sm:w-8 sm:h-8 md:w-9 md:h-9 lg:w-8 lg:h-8 xl:w-10 xl:h-10 text-red-600 hover:text-red-700" />
                </a>
              </div>
            </div>
          </div>

          <div className='grid grid-cols-1 sm:grid-cols-2 gap-4 sm:gap-6 md:gap-4 lg:gap-6 xl:gap-8 mt-6 sm:mt-8'>
            <a 
              href="/#Contact"    
              className="w-full max-w-[320px] sm:max-w-[280px] md:max-w-[300px] lg:max-w-[280px] xl:max-w-[320px] flex justify-center items-center mx-auto cursor-pointer text-base sm:text-lg md:text-xl lg:text-lg xl:text-xl text-white bg-gradient-to-r from-purple-500 to-purple-500 font-medium px-4 sm:px-6 md:px-8 py-3 sm:py-3 md:py-4 rounded-xl transition duration-300 shadow-md hover:shadow-lg hover:scale-105 hover:bg-gradient-to-r hover:from-purple-500 hover:to-purple-500"
            >
              Me contacter
            </a>

            <a
              href={CV}
              download="Gautier_VASSE_CV.pdf"
              className="w-full max-w-[320px] sm:max-w-[280px] md:max-w-[300px] lg:max-w-[280px] xl:max-w-[320px] flex justify-center items-center mx-auto cursor-pointer text-base sm:text-lg md:text-xl lg:text-lg xl:text-xl border-2 border-purple-700 text-purple-700 font-medium px-4 sm:px-6 md:px-8 py-3 sm:py-3 md:py-4 rounded-xl hover:border-green-500 hover:text-green-500 transition duration-300 hover:shadow-lg hover:scale-105"
            >
              Télécharger CV
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
